<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" append-to-body
    :destroy-on-close="true" :before-close="cancel">
    <div class="el-descriptions-div">
      <el-descriptions :column="2" :labelStyle="{'width':'125px', 'font-size': '15px', 'font-weight': 'bold'}"
        :contentStyle="{ 'font-size': '16px', 'width':'475px'}">
        <el-descriptions-item label="状态" :span="(rejectionReason!=='' && rejectionReason !== null)?1:2">
          <el-tag :type="getStatusColor(status,'tagType')"
            :style="{color: getStatusColor(status,'color'),'background-color':getStatusColor(status,'backgroundColor')}">
            {{getStatusColor(status,'name')}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="驳回原因" v-if="rejectionReason!=='' && rejectionReason !== null">{{ rejectionReason
          }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ createBy }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{createTime}}</el-descriptions-item>
        <el-descriptions-item label="审核" v-if="operatingPersonName!==''">{{ operatingPersonName
          }}</el-descriptions-item>
        <el-descriptions-item label="合同审核时间" v-if="operatingTime!==''">{{operatingTime}}</el-descriptions-item>
        <el-descriptions-item label="销售">{{salesName}}</el-descriptions-item>
        <el-descriptions-item label="合同拟定时间">{{contractDraftingDate}}</el-descriptions-item>
        <el-descriptions-item label="合同分类">
          <el-tag :type="getContractColor(contractType, 'tagType')" :style="{
            color: getContractColor(contractType, 'color'),
            'background-color': getContractColor(contractType, 'backgroundColor'),
            'border-color': getContractColor(contractType, 'borderColor')
          }">{{ getContractColor(contractType, 'name') }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="合同类型">
          <el-tag type="warning">{{ projectType }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="样品处理方式"
          v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(projectType)">
          {{ sampleManagement }}
        </el-descriptions-item>
        <el-descriptions-item label="分析要求"
          v-if="['预付款扣款（测序分析）','测序分析'].includes(projectType)">{{analysisRequest}}</el-descriptions-item>
        <el-descriptions-item label="更多分析要求"
          v-if="['预付款扣款（测序分析）','测序分析'].includes(projectType)">{{formattedMoreAnalysis.join(',')}}</el-descriptions-item>
        <el-descriptions-item :label="item+'金额'" v-for="(item,index) in formattedMoreAnalysis" :key="index"
          v-if="['预付款扣款（测序分析）','测序分析'].includes(projectType)">{{translatedObject[item]}}</el-descriptions-item>
        <el-descriptions-item label="高级分析附件" v-if="seniorAnalysisAnnex!==''">
          <el-button size="mini" type="primary" icon="el-icon-download" @click="download(id,'contract')">下载</el-button>
          <el-button size="mini" type="primary" icon="el-icon-view" @click="preview(id,'contract')">预览</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="个性化分析附件" v-if="customizedAnalysisAnnex!==''">
          <el-button size="mini" type="primary" icon="el-icon-download" @click="download(id,'contract')">下载</el-button>
          <el-button size="mini" type="primary" icon="el-icon-view" @click="preview(id,'contract')">预览</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="合同名称"
          :contentStyle="{'font-size': '15px', 'font-weight': 'bold'}">{{contractName}}</el-descriptions-item>
        <el-descriptions-item label="合同编号" :contentStyle="{'font-size': '15px', 'font-weight': 'bold'}">{{
          contractNumber }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="2"
        :labelStyle="{'width':'125px', 'font-size': '15px', 'font-weight': 'bold', 'height':'28px'}"
        :contentStyle="{ 'font-size': '16px', 'width':'225px'}" v-for="(item,index) in project"
        :key="'projectType' + index">
        <el-descriptions-item :label="'项目'+(index+1)+'分类'">{{item.model}}</el-descriptions-item>
        <el-descriptions-item :label="'项目'+(index+1)+'类型'">{{item.name}}</el-descriptions-item>
        <el-descriptions-item label="样本数量">{{item.numberOfSamples}}</el-descriptions-item>
        <el-descriptions-item label="样本数据量">{{item.sizeOfSampleData}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="2"
        :labelStyle="{'width':'125px', 'font-size': '15px', 'font-weight': 'bold', 'height':'28px'}"
        :contentStyle="{ 'font-size': '16px', 'width':'225px'}">
        <el-descriptions-item label="合同金额">{{contractAmount}}</el-descriptions-item>
        <el-descriptions-item label="增值金额"
          v-if="['PREPAYMENTS','IMPORT_PREPAYMENTS'].includes(contractType)">{{ addedAmount + '(' +
  getProportion(contractAmount, addedAmount) + ')' }}</el-descriptions-item>
        <el-descriptions-item
          label="可开票金额">{{['PREPAYMENTS','FORMAL','IMPORT_PREPAYMENTS'].includes(contractType)?invoicedAmount:'NA'}}</el-descriptions-item>
        <el-descriptions-item label="执行合同编号">{{executeContractNumber}}</el-descriptions-item>
        <el-descriptions-item label="有效期限">
          <el-tag>{{expirationDate + '年'}}</el-tag>
        </el-descriptions-item>
        <!--        <el-descriptions-item label="签订时间">{{signingDate}}</el-descriptions-item>-->
        <el-descriptions-item label="签订地点">{{signingPlace}}</el-descriptions-item>
        <el-descriptions-item label="受托方">{{trusteeCompany}}</el-descriptions-item>
        <el-descriptions-item label="客户联系人">{{customerContacts}}</el-descriptions-item>
        <el-descriptions-item label="受托方联系人">{{trusteeContacts}}</el-descriptions-item>
        <el-descriptions-item label="备注">{{remark}}</el-descriptions-item>
      </el-descriptions>
    </div>
    <br><br>
    <el-form label-width="120px" ref="form" :model="form" :rules="rules">
      <el-form-item label="转预付款金额" prop="amount">
        <el-input style="width: 360px;" size="small" v-model="form.amount" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="原因" prop="remark">
        <el-input style="width: 360px;" :autosize="{ minRows: 3}" type="textarea" maxlength="300" show-word-limit
          placeholder="请输入内容" size="small" v-model="form.remark" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" class="title" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="handle">减值</el-button>
    </div>
  </el-dialog>
</template>

<script>

import {checkNum} from "@/utils/rules";
import {attachmentContract, impairmentContract} from "@/api/dilivery/sales/contract";
import {getProjectList} from "@/api/dilivery/project";
import {getContractColor, getStatusColor} from "@/color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { getProportion } from "@/utils/float_decimal";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "AddImpairment",
  props:['showDialog','selectDetail'],
  data(){
    return{
      title:'转预付款',
      id: '',
      createBy:'',
      createTime:'',
      executeContractNumber:'',
      salesName:'',
      contractDraftingDate:'',
      contractType:'',
      projectType:'',
      contractAmount:'',
      addedAmount:'',
      invoicedAmount:'', // 已收票金额
      contractNumber:'', //合同编号
      contractName:'', //合同名称
      signingDate:'', //签订时间
      signingPlace:'', //签订地点
      expirationDate:'',//有效期限
      customerContacts:'', //客户联系人
      trusteeCompany:'', //受托方
      trusteeContacts:'', //受托方联系人
      remark:'',
      status:'',
      rejectionReason:'',
      operatingPersonName:'',
      operatingTime:'',
      analysisRequest: '',//分析要求
      moreAnalysis: [],//更多分析要求
      moreAnalysisRequest:{},
      seniorAnalysisAnnex: '',//高级分析附件
      customizedAnalysisAnnex: '',//个性化分析附件
      ProjectOption: [],//项目
      specificProjectType:[],
      sampleManagement: null,//样品处理方式
      form:{
        id:'',
        amount: 0,
        remark:''
      },
      rules: {
        amount:[
          {required: true,message: '请输入转预付款金额', trigger: 'change'},
          {validator:checkNum, trigger: 'change'}
        ],
        remark: [
          {required: true, message: '请输入转换原因', trigger: 'change'}
        ],
      },
    }
  },
  computed: {
    formattedMoreAnalysis() {
      return this.moreAnalysis.map(item => {
        switch (item) {
          case 'SENIOR_ANALYSIS':
            return '高级分析';
          case 'CUSTOMIZED_ANALYSIS':
            return '个性化分析';
          default:
            return item;
        }
      });
    },
    translatedObject() {
      const newObject = {};
      for (const key in this.moreAnalysisRequest) {
        let newKey = key;
        switch (key) {
          case 'SENIOR_ANALYSIS':
            newKey = '高级分析';
            break;
          case 'CUSTOMIZED_ANALYSIS':
            newKey = '个性化分析';
            break;
          default:
            break;
        }
        newObject[newKey] = this.moreAnalysisRequest[key];
      }
      return newObject;
    },
    project() {
      return this.specificProjectType.map(item => {
        const type = this.ProjectOption.find(itemB => itemB.id === item.projectMainTypeId)
        if(type){
          return {
            ...item,
            ...type
          }
        }else{
          return {
            ...item,
            model: '',
            name: ''
          }
        }
      })
    }
  },
  watch:{
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.id = newVal.id
          this.createBy = newVal.createBy
          this.createTime = newVal.createTime
          this.executeContractNumber = newVal.executeContractNumber
          this.salesName = newVal.sales.name
          this.contractDraftingDate = newVal.contractDraftingDate
          this.contractType = newVal.contractType
          this.projectType = newVal.projectType
          this.contractAmount = newVal.contractAmount
          this.addedAmount = newVal.addedAmount
          this.invoicedAmount = newVal.invoicedAmount
          this.contractNumber = newVal.contractNumber
          this.contractName = newVal.contractName
          this.signingDate = newVal.signingDate
          this.signingPlace = newVal.signingPlace
          this.expirationDate = newVal.expirationDate
          this.customerContacts = newVal.customerContacts.contactName
          this.trusteeCompany = newVal.baseCompany.companyName
          this.trusteeContacts = newVal.trusteeContacts.name
          this.rejectionReason = newVal.rejectionReason
          this.remark = newVal.remark
          this.status = newVal.status
          switch (newVal.sampleManagement) {
            case 'RETURN_SAMPLE':
              this.sampleManagement = '返样'
              break
            case 'SAMPLE_HOLD':
              this.sampleManagement = '暂存样品'
              break
            default:
              break
          }
          if(newVal.analysisRequest){
            this.analysisRequest = newVal.analysisRequest === 'STANDARD_ANALYSIS'?'标准分析':''
          }else{
            this.analysisRequest = ''
          }
          if(newVal.moreAnalysisRequest){
            this.moreAnalysis = Object.keys(newVal.moreAnalysisRequest)
            this.moreAnalysisRequest = {...newVal.moreAnalysisRequest}
          }else{
            this.moreAnalysis = []
            this.moreAnalysisRequest = {}
          }
          if(newVal.seniorAnalysisAnnex){
            this.seniorAnalysisAnnex = newVal.seniorAnalysisAnnex
          }else{
            this.seniorAnalysisAnnex = ''
          }
          if(newVal.customizedAnalysisAnnex){
            this.customizedAnalysisAnnex = newVal.customizedAnalysisAnnex
          }else{
            this.customizedAnalysisAnnex = ''
          }
          if(newVal.specificProjectType){
            this.specificProjectType = newVal.specificProjectType
            this.getProjectOption(newVal.specificProjectType.map(item => Number(item['projectMainTypeId'])))
          }else{
            this.specificProjectType = []
            this.ProjectOption = []
          }
          if(newVal.operatingPersonName!==null){
            this.operatingPersonName = newVal.operatingPersonName
            this.operatingTime = newVal.operatingTime
          }
        }
      },
      immediate:true
    },
  },
  mounted() {
  },
  methods:{
    getProportion,
    getStatusColor,
    getContractColor,
    getProjectOption(list) {
      let data = {
        "query#id.IN":list.join(',')
      }
      getProjectList(data).then(res => {
        if(res.code === 200){
          this.ProjectOption = res.data
        }
      })
    },
    async download(id, type) {
      try {
        let annex;
        switch (type) {
          case 'contract':
            annex = 'CONTRACT_ANNEX'
            break
          case 'senior':
            annex = 'SENIOR_ANALYSIS_ANNEX'
            break
          case 'customized':
            annex = 'CUSTOMIZED_ANALYSIS_ANNEX'
            break
          default:
            break
        }
        let url = `${baseURL}/sequencing-contract/attachment/${id}/${annex}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async preview(id,type){
      try {
        switch (type){
          case 'contract':
            this.fileInfo = await attachmentContract(id,'CONTRACT_ANNEX')
            break
          case 'senior':
            this.fileInfo = await attachmentContract(id,'SENIOR_ANALYSIS_ANNEX')
            break
          case 'customized':
            this.fileInfo = await attachmentContract(id,'CUSTOMIZED_ANALYSIS_ANNEX')
            break
          default:
            break
        }
        this.showFile = true
      } catch (error) {
        console.log(error);
      }
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      this.$refs.form.validate(valid=>{
        if(valid){
          impairmentContract(this.form).then(res=>{
            if(res.code === 200){
              this.$emit('submit','confirm')
              this.$messageUi.success('转预付款成功')
            }
          }).catch(err => {

          })
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";

.el-descriptions-div {
  @include thin-scrollbar(8px, #888);
  max-height: 45vh;
  /* 你还可以在这个类里写其他样式 */
  background: #fff;
}

</style>